import React from 'react'
import styles from './MenuButton.module.css'
import IconMenu from '../../../../assets/icons/IconMenu'

const MenuButton = ({onClick}) => {
    return (
        <div className={styles.container} onClick={onClick}>
            <IconMenu size={24}/>
        </div>
    )
}

export default MenuButton
